import { logEvent } from 'firebase/analytics';
import { analytics } from '../App';

export const trackImageApproved = (placeId, contentId, farmId, approvedBy) => {
	logEvent(analytics, `image_approved`, {
		placeId,
		contentId,
		farmId,
		approvedBy,
	});
};

export const trackImageRejected = (placeId, contentId, farmId, rejectedBy) => {
	logEvent(analytics, `image_rejected`, {
		placeId,
		contentId,
		farmId,
		rejectedBy,
	});
};

export const trackCreatedGeofence = (
	placeId,
	parentPoint,
	farmId,
	createdBy,
) => {
	logEvent(analytics, `geofence_inserted`, {
		placeId,
		parentPointSignature: parentPoint,
		farmId,
		createdBy,
	});
};

export const trackEditedGeofence = (
	oldPlaceId,
	parentPoint,
	farmId,
	editedBy,
) => {
	logEvent(analytics, `geofence_edited`, {
		oldPlaceId,
		parentPointSignature: parentPoint,
		farmId,
		editedBy,
	});
};

export const trackDeletedGeofence = (
	placeId,
	parentPoint,
	farmId,
	deletedBy,
) => {
	logEvent(analytics, `geofence_deleted`, {
		placeId,
		parentPointSignature: parentPoint,
		farmId,
		deletedBy,
	});
};

export const trackInvalidGeofenceDrawn = (
	placeId,
	parentPoint,
	farmId,
	createdBy,
	validationMessage,
) => {
	logEvent(analytics, `invalid_geofence_drawn`, {
		placeId,
		parentPointSignature: parentPoint,
		farmId,
		createdBy,
		validationMessage,
	});
};

export const trackGeofenceCreationError = (
	placeId,
	parentPoint,
	farmId,
	createdBy,
	error,
) => {
	logEvent(analytics, `failed_geofence_creation`, {
		placeId,
		parentPointSignature: parentPoint,
		farmId,
		createdBy,
		error,
	});
};

export const trackGeofenceUpdationError = (
	placeId,
	parentPoint,
	farmId,
	updatedBy,
	error,
) => {
	logEvent(analytics, `failed_geofence_updation`, {
		placeId,
		parentPointSignature: parentPoint,
		farmId,
		updatedBy,
		error,
	});
};

export const trackGeofenceDeletionError = (
	placeId,
	parentPoint,
	farmId,
	deletedBy,
	error,
) => {
	logEvent(analytics, `failed_geofence_deletion`, {
		placeId,
		parentPointSignature: parentPoint,
		farmId,
		deletedBy,
		error,
	});
};

export const trackMachineTelematics = (machineId, startDate, endDate) => {
	logEvent(analytics, `machine telematics`, {
		machineId,
		startDate,
		endDate,
	});
};
